import { CASE_STATUS_LABELS } from '../config/labels';

interface StatusBadgeProps {
  status: string;
  size?: 'sm' | 'md';
}

const STATUS_STYLES: Record<string, string> = {
  DRAFT: 'bg-slate-100 text-slate-600 border-slate-300',
  INTAKE: 'bg-blue-100 text-blue-700 border-blue-300',
  PUBLIC_LOOKUP: 'bg-indigo-100 text-indigo-700 border-indigo-300',
  DOC_ANALYSIS: 'bg-purple-100 text-purple-700 border-purple-300',
  SCORING: 'bg-amber-100 text-amber-700 border-amber-300',
  SUMMARY: 'bg-cyan-100 text-cyan-700 border-cyan-300',
  PENDING_DETERMINATION: 'bg-orange-100 text-orange-700 border-orange-300',
  DETERMINED: 'bg-green-100 text-green-700 border-green-300',
  CLOSED: 'bg-slate-200 text-slate-600 border-slate-400',
  ESCALATED: 'bg-red-100 text-red-700 border-red-300',
};

export default function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const label = CASE_STATUS_LABELS[status] || status;
  const style = STATUS_STYLES[status] || 'bg-slate-100 text-slate-700 border-slate-300';
  const sizeStyle = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-2.5 py-1';
  return (
    <span
      className={`inline-flex items-center rounded-full border font-medium ${style} ${sizeStyle}`}
    >
      {label}
    </span>
  );
}